import Vue from "vue";

Vue.component("InputComponent", () => import("./components/element/InputComponent.vue"));
Vue.component("ButtonStyle", () => import("./components/element/ButtonStyle.vue"));
Vue.component("DropdownComponent", () => import("./components/element/DropdownComponent.vue"));
Vue.component("CalendarSinglePicker", () => import("./components/element/CalendarSinglePicker.vue"));
Vue.component("SwitchComponent", () => import("./components/element/SwitchComponent.vue"));
Vue.component("CheckBox", () => import("./components/element/CheckBox.vue"));
Vue.component("Radio", () => import("./components/element/Radio.vue"));
Vue.component("ModalBox", () => import("./components/modal/ModalBox.vue"));
Vue.component("ModalBoxAdvanced", () => import("./components/modal/ModalBoxAdvanced.vue"));
Vue.component("TextArea", () => import("./components/element/TextArea.vue"));
Vue.component("OtpInput", () => import("./components/element/OtpInput.vue"));
Vue.component("ModalCanNotCreateDocument", () => import("./components/modal/ModalCanNotCreateDocument.vue"));

//transactionCreate
Vue.component("SectionHeader", () => import("./components/transactionCreate/SectionHeader.vue"));
Vue.component("SectionContact", () => import("./components/transactionCreate/SectionContact.vue"));
Vue.component("SectionClassification", () => import("./components/transactionCreate/SectionClassification.vue"));
Vue.component("SectionItemProductList", () => import("./components/transactionCreate/SectionItemProductList.vue"));
Vue.component("SectionSummary", () => import("./components/transactionCreate/SectionSummary.vue"));
Vue.component("SectionPayment", () => import("./components/transactionCreate/SectionPayment.vue"));
Vue.component("SectionTaxInvoice", () => import("./components/transactionCreate/SectionTaxInvoice.vue"));
Vue.component("SectionReceivedTaxInvoice", () =>
  import("./components/transactionCreate/SectionReceivedTaxInvoice.vue")
);
Vue.component("SectionDescription", () => import("./components/transactionCreate/SectionDescription.vue"));
Vue.component("SectionUploadFile", () => import("./components/transactionCreate/SectionUploadFile.vue"));
Vue.component("SectionTagList", () => import("./components/transactionCreate/SectionTagList.vue"));
